import { useMemo } from 'react'
import { Channel, useDmsAndGdms } from 'use-towns-client'

export const useDmChannels = (): Channel[] => {
    const { dmsAndGdms } = useDmsAndGdms()
    const channels = useMemo(
        () =>
            dmsAndGdms.map((c) => {
                return {
                    id: c.id,
                    label: '',
                    isAutojoin: false,
                    isDefault: false,
                    hideUserJoinLeaveEvents: false,
                    disabled: false,
                } satisfies Channel
            }),
        [dmsAndGdms],
    )
    return channels
}
